import i18n from 'i18next';
import {
  EMarketStatisticsTemplate,
  IMarketStatisticsType
} from 'interfaces/market-statistic';

export const Markets_Tooltips: Record<string, string> = {
  get MatchResult() {
    return i18n.t('marketsTooltips.MatchResult');
  },
  get P1XP2() {
    return i18n.t('marketsTooltips.MatchResult');
  },
  get '1X12X2'() {
    return i18n.t('marketsTooltips.DoubleChance');
  },
  get DrawNoBet() {
    return i18n.t('marketsTooltips.DrawNoBet');
  },
  get HalfTimeResult() {
    return i18n.t('marketsTooltips.HalfTimeResult');
  },
  get SecondHalfResult() {
    return i18n.t('marketsTooltips.SecondHalfResult');
  },
  get HalfTimeFullTime() {
    return i18n.t('marketsTooltips.HalfTimeFullTime');
  },
  get '2ndHalfTotalOver/Under'() {
    return i18n.t('marketsTooltips.SecondHalfEvenOddTotal');
  },
  get CorrectScore() {
    return i18n.t('marketsTooltips.CorrectScore');
  },
  get OverUnder() {
    return i18n.t('marketsTooltips.OverUnder');
  },
  get OverUnder2() {
    return i18n.t('marketsTooltips.OverUnder');
  },
  get HalfTimeOverUnder() {
    return i18n.t('marketsTooltips.HalfTimeOverUnder');
  },
  get BothTeamsToScore() {
    return i18n.t('marketsTooltips.BothTeamsToScore');
  },
  get YellowCardsOverUnder() {
    return i18n.t('marketsTooltips.yellowCardsOverUnder');
  },
  get MatchYellowCardLastTeam() {
    return i18n.t('marketsTooltips.matchYellowCardLastTeam');
  },
  get Team1YellowCardsOverUnder() {
    return i18n.t('marketsTooltips.Team1YellowCardsOverUnder');
  },
  get Team2YellowCardsOverUnder() {
    return i18n.t('marketsTooltips.Team2YellowCardsOverUnder');
  },
  get '1stHalfYellowCardsOver/Under'() {
    return i18n.t('marketsTooltips.1stHalfYellowCardsOverUnder');
  },
  get 'YellowCards:1stHalfTeam1Total'() {
    return i18n.t('marketsTooltips.YellowCards1stHalfTeam1Total');
  },
  get YellowCards1stHalfTeam2Total() {
    return i18n.t('marketsTooltips.YellowCards1stHalfTeam2Total');
  },
  get '2ndHalfYellowCardsOver/Under'() {
    return i18n.t('marketsTooltips.2ndHalfYellowCardsOverUnder');
  },
  get 'YellowCards:2ndHalfTeam1Total'() {
    return i18n.t('marketsTooltips.1stHalfYellowCardsOverUnder');
  },
  get 'YellowCards:2ndHalfTeam2Total'() {
    return i18n.t('marketsTooltips.YellowCards2ndHalfTeam2Total');
  },
  get HalfWithTheMostYellowCards() {
    return i18n.t('marketsTooltips.HalfWithTheMostYellowCards');
  }
};

// this tooltips are not listen to Spring Configs MARKETS_TOOLTIPS parameter
export const EXTERNAL_MARKET_TOOLTIPS: Record<string, string> = {
  get 'MatchWinner(RetirementInsured)'() {
    return i18n.t('marketsTooltips.MatchWinnerRetirementInsured');
  }
};

export const AVAILABLE_MARKET_STATISTICS: Record<
  string,
  IMarketStatisticsType
> = {
  P1XP2: {
    statisticsMarketType: 'GetStatsForMatch',
    marketTypeDetalis: 'P1XP2',
    template: EMarketStatisticsTemplate.LastFiveMeetings,
    get title() {
      return i18n.t('sportsbook.lastFiveMeetingResultsHtFt');
    },
    type: 'FT',
    emptyHeight: '90'
  },
  CorrectScore: {
    statisticsMarketType: 'GetStatsForMatch',
    marketTypeDetalis: 'CorrectScore',
    template: EMarketStatisticsTemplate.LastFiveMeetings,
    get title() {
      return i18n.t('sportsbook.lastFiveMeetingResultsFt');
    },
    emptyHeight: '90'
  },
  HalfTimeResult: {
    statisticsMarketType: 'GetStatsForMatch',
    marketTypeDetalis: 'HalfTimeResult',
    template: EMarketStatisticsTemplate.LastFiveMeetings,
    get title() {
      return i18n.t('sportsbook.lastFiveMeetingResultsHt');
    },
    type: 'HT',
    emptyHeight: '90'
  },
  HalfTimeFullTime: {
    statisticsMarketType: 'GetHalfTimeFullTimePerformance',
    marketTypeDetalis: 'HalfTimeFullTime',
    template: EMarketStatisticsTemplate.LastFiveMatchesAvg,
    get title() {
      return i18n.t('sportsbook.wdlListByTeam');
    },
    emptyHeight: '138'
  },
  '1stHalfBothTeamsToScore': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: '1stHalfBothTeamsToScore',
    marketCallType: '3',
    marketDataKey_individual: 'FirstHalfGoals',
    marketDataKey_H2H: 'BothTeamsFirstHalfGoals',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasThereGoalFh');
    },
    type: 'BothTeamsFirstHalfGoals',
    emptyHeight: '128'
  },
  BothTeamsToScore: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'BothTeamsToScore',
    marketCallType: '1',
    marketDataKey_individual: 'BothTeamsFullTimeGoals',
    marketDataKey_H2H: '',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasThereGoalFt');
    },
    type: 'BothTeamsFullTimeGoals',
    emptyHeight: '128'
  },
  '2ndHalfBothTeamsToScore': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: '2ndHalfBothTeamsToScore',
    marketCallType: '3',
    marketDataKey_individual: 'SecondHalfGoals',
    marketDataKey_H2H: 'BothTeamsSecondHalfGoals',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasThereGoalSh');
    },
    type: 'SecondHalfGoals',
    emptyHeight: '128'
  },
  '1stHalf-2ndHalfBothToScore': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: '1stHalf-2ndHalfBothToScore',
    marketCallType: '3',
    marketDataKey_individual: 'FullTimeGoals',
    marketDataKey_H2H: 'BothTeamsFullTimeGoals',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasThereGoalInMatch');
    },
    type: 'BothTeamsFullTimeGoals',
    emptyHeight: '128'
  },
  'Team1ScoreYes/no': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'Team1ScoreYes/no',
    marketCallType: '2',
    marketDataKey_H2H: 'FullTimeGoals',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasTeamScoringGoalsMatch');
    },
    emptyHeight: '128'
  },
  'Team2ScoreYes/No': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'Team2ScoreYes/No',
    marketCallType: '2',
    marketDataKey_H2H: 'FullTimeGoals',
    template: EMarketStatisticsTemplate.Results,
    get title() {
      return i18n.t('sportsbook.wasTeamScoringGoalsMatch');
    },
    emptyHeight: '128'
  },
  Team1TotalGoalsExact: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'Team1TotalGoalsExact',
    marketCallType: '3',
    marketDataKey_individual: 'FullTimeGoalsAvg',
    marketDataKey_H2H: 'FullTimeScoredGoalsAvg',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageFullTimeGoals');
    },
    emptyHeight: '138'
  },
  Team1OverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'Team1OverUnder',
    marketCallType: '1',
    marketDataKey_individual: 'FullTimeGoalsAvg',
    marketDataKey_H2H: '',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageFullTimeGoals');
    },
    emptyHeight: '138'
  },
  Team2OverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'Team1OverUnder',
    marketCallType: '1',
    marketDataKey_individual: 'FullTimeGoalsAvg',
    marketDataKey_H2H: '',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageFullTimeGoals');
    },
    emptyHeight: '138'
  },
  SecondHalfHomeTeamTotalGoalsOverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'SecondHalfHomeTeamTotalGoalsOverUnder',
    marketCallType: '1',
    marketDataKey_individual: 'SecondHalfGoalsAvg',
    marketDataKey_H2H: '',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageSecondHalfGoals');
    },
    emptyHeight: '138'
  },
  SecondHalfAwayTeamTotalGoalsOverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'SecondHalfAwayTeamTotalGoalsOverUnder',
    marketCallType: '1',
    marketDataKey_individual: 'SecondHalfGoalsAvg',
    marketDataKey_H2H: '',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageSecondHalfGoals');
    },
    emptyHeight: '138'
  },
  OverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'OverUnder',
    marketCallType: '2',
    marketDataKey_H2H: 'FullTimeGoalsAvg',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageFullTimeGoals');
    },
    emptyHeight: '138'
  },
  '2ndHalfTotalOver/Under_': {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: '2ndHalfTotalOver/Under',
    marketCallType: '2',
    marketDataKey_H2H: 'SecondHalfGoalsAvg',
    template: EMarketStatisticsTemplate.GoalScored,
    title: '',
    emptyHeight: '138'
  },
  HalfTimeOverUnder: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'HalfTimeOverUnder',
    marketCallType: '2',
    marketDataKey_H2H: 'FirstHalfScoredGoalsAvg',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageFirstHalfGoalsScored');
    },
    emptyHeight: '138'
  },
  SecondHalfAwayTeamTotalGoalsInterval: {
    statisticsMarketType: 'GetScoredGoalsStatistics',
    marketTypeDetalis: 'SecondHalfAwayTeamTotalGoalsInterval',
    marketCallType: '2',
    marketDataKey_H2H: 'SecondHalfScoredGoalsAvg',
    template: EMarketStatisticsTemplate.GoalScored,
    get title() {
      return i18n.t('sportsbook.averageSecondHalfGoals');
    },
    emptyHeight: '138'
  }
};
